import IDate from '@dvrd/idate';
import {ICalendarEvent, ModelResponse} from './interfaces';
import {getCalendarEvents} from "./requestSender";
import {ResponseData} from '@dvrd/fetch';

export class CalendarEvent {
    readonly summary: string;
    readonly description: string;
    private readonly start: string;
    private readonly end: string;

    static getEvents = (startDate: IDate, endDate: IDate,
                        callback: ModelResponse<Array<CalendarEvent>>) => {
        getCalendarEvents({
            start_date: startDate, end_date: endDate, callback: (data: ResponseData) => {
                const events = data.success ? data.events.map((evt: any) => new CalendarEvent(evt)) : [];
                callback(events, data.success, data);
            }
        });
    };

    constructor(event: ICalendarEvent) {
        this.summary = event.summary;
        this.description = event.description;
        this.start = event.start;
        this.end = event.end;
    }

    get startDate(): IDate {
        return new IDate(this.start);
    }

    get endDate(): IDate {
        return new IDate(this.end);
    }
}

export function getCalendarDates(start: IDate, end: IDate): [IDate, IDate] {
    const startDay = start.weekday();
    const endDay = end.weekday();
    const padStart = startDay === 0 ? 6 : startDay - 1;
    const padEnd = endDay === 0 ? 0 : 7 - endDay;
    return [start.clone().subtract(padStart, 'days'), end.clone().add(padEnd, 'days')];
}

export function getRenderDates(start: IDate, end: IDate): Array<IDate> {
    const [startDate, endDate] = getCalendarDates(start, end);
    const dates: Array<IDate> = [];
    let date = startDate.clone();
    while (date.isAtOrBefore(endDate)) {
        dates.push(date.clone());
        date = date.add(1, 'day');
    }
    return dates;
}

export const NL_WEEKDAYS = ['Maandag', 'Dinsdag', 'Woensdag', 'Donderdag', 'Vrijdag', 'Zaterdag', 'Zondag'];
export const EN_WEEKDAYS = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];